export default {
  async fetchCostCenters({ commit }) {
    try {
      const {
        data: { costCenters },
      } = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/cost-centers`);
      commit('setCostCenters', costCenters);
    } catch {}
  },
};
